import iziToast from 'izitoast/dist/js/iziToast.min.js';
import Message from "../components/Message";
export default (function (w, d) {
    'use strict';

    function DeleteProductsProfile() {
        this.init();
    }

    DeleteProductsProfile.prototype.init = function () {
        $('.remove a').on('click', function(e) {

            e.preventDefault();
            let url = $(this).attr('data-url');
            let product_id = $(this).attr('data-product-id');
            $.ajax({
                url: url,
                type: 'DELETE',
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                data: {
                    product_id: product_id
                },
                success: function(response) {
                    if ( response.status === 'success' ) {
                        new Message('Product deleted', 'success');
                        location.reload();
                    }
                }
            });
        });
    }

    return DeleteProductsProfile;
}(window, document));

